/**
 * NotificationCountKind
 *
 * The four count-based, media-trailing notification sub-types rendered by
 * `NotificationCountItem`. Web-local discriminant (no Flutter enum to
 * ordinal-match); string-valued for clearer debugging, mirroring
 * `inboxItemType.ts`. Per `conventions.md` § "Enums live in the domain layer",
 * it lives in the domain layer even though its first consumer is
 * presentation-local.
 */
export enum NotificationCountKind {
  contentLike = 'contentLike',
  contentComment = 'contentComment',
  commentLike = 'commentLike',
  commentReply = 'commentReply',
}
